import React from "react";
import {Link} from 'react-router-dom'
import './Classical.css'


const Classical=()=>{
    return(
    <div className="classic">
     <h1 className="asia">A South Asian Tradition</h1>  
     <br/>
            <p className="asia-para">It is almost impossible to spend a day in any North Indian city and not hear the sounds of the tabla. Whether coming from a music shop, a motor rickshaw’s stereo, or a temple, the tabla is everywhere.

            The most well-known drum of North India, the tabla is found in a broad range of musical styles and traditions, including classical, folk, devotional, and popular music, such as Bollywood film songs.

            But the tabla is most often associated with the classical North Indian music known as Hindustani, or Shastriya Sangeet. 
            </p>
            <br/>
            <div className="abroad-div">
            <img className="abroad" src="  https://upload.wikimedia.org/wikipedia/commons/5/5e/6_ancient_drum_types_of_Madhya_Pradesh%2C_Indian_subcontinent.jpg" alt="abroad"/>
         
            </div>
            <br/>
            <h1 className="asia">Classical Tabla Abroad</h1>  
            <br/>
            <p className="asia-para">Of course, Indians need no introduction to classical Indian music or the tabla. But outside of South Asia, most people still understand very little about the music, much less the tabla.

            This may seem surprising. Western popular culture first learned of classical Indian music back in the late 1960s. And since that time, a steady stream of Westerners has been studying the music, both in India and the West.

            In recent decades, there has also been a growing interest in so-called “World Music”, especially percussion. Latin, African, and Middle Eastern drums are now commonly studied and performed in the urban West 
            Yet to this day, classical Indian tabla remains a mystery to most people outside of South Asia. This says a lot about how unusual, and how difficult, the tabla is.

            But for those who learn enough to start following the music, they often discover that it is well worth their time. Especially for those who like drumming and rhythm, the tabla often fascinates new listeners.

            And for those who learn to play the tabla—myself included—it sometimes becomes a life-long obsession.
            </p>
             <br/>
            <div className="abroad-div">
            <img className="abroad" src="https://upload.wikimedia.org/wikipedia/commons/7/7f/Djembes.jpg" alt="abroad"/>
         
            </div>
              <br/>
            <h1 className="asia">The Wonder of Classical Tabla</h1>  
            <br/>
            <p className="asia-para">In the West, people often categorize the tabla as “World Percussion”, together with other popular hand drums, such as the conga, djembe, or darbuka.

                But classical tabla has little in common with these traditions. In fact, the tabla has relatively little in common with any drumming tradition outside of South Asia.

                With its clear bell-like tone, its highly intricate and expressive phrasings, and the sensuous inflections of the bass drum, the tabla sounds unlike any other drum.

                And among hand drums, there is no other tradition which compares to the tabla’s depth, variety, and complexity, except for other Indian traditions such as the pakhawaj or the South Indian mrdangam.

                But what is most remarkable about classical tabla is that the repertoire is primarily solo in nature; its compositions and improvisations are made mostly of independent phrases and patterns, and not repetitive rhythms or grooves.    
            </p>
            <br/>
            <div className="abroad-div">
            <img className="abroad" src="https://upload.wikimedia.org/wikipedia/commons/e/e4/Prop._Tabla.jpg" alt="abroad"/>
         
            </div>
            <br/>
            <h1 className="asia">A Solo Repertoire</h1> 
            <br/> 
            <p className="asia-para">
            Most often, you will hear classical tabla in accompaniment (tabla in vocal or instrumental music). But most of the classical tabla repertoire is performed only in tabla solo, or in practice in the manner of tabla solo.

                In other words, most of classical tabla is tabla solo; almost all of the compositions on this website are performed or practiced in tabla solo, from the simplest beginner kayda, to the most advanced gat or chakradar.

                And this is where classical tabla players will spend their formative years, if not most of their tabla lives: practicing in the mode of tabla solo, whether they are accompanists or not. In this sense, all tabla players are soloists.

                Some of India’s most famous tabla players are, or were, primarily soloists. Some of them were not especially good accompanists, or never accompanied at all.

                Ahmed Jan Thirakwa Khan, who many believe was the greatest tabla player of his generation, was known mostly as a soloist. Though he was also considered a fine accompanist, it was Thirakwa’s tabla solos that were so influential, and to which people continue to listen over and over.
             </p>
             <br/>
            <div className="abroad-div">
            <img className="abroad" src="http://photos1.blogger.com/blogger/7345/1407/1600/thirakwa2.jpg" alt="abroad"/>
         
            </div>
             <br/>
             <h1 className="asia">The Difficulty of Classical Tabla</h1>  
             <br/>
            <p className="asia-para">
            Mickey Hart, drummer for The Grateful Dead and World Music pioneer, was interviewed by Peter Lavezzoli for his book The Dawn of Indian Music in the West. When asked what he found unique about the tabla’s approach, Hart said,

                First it was the complexity, which was astounding. I couldn’t make heads or tails of it. Every other kind of rhythm, I could at least lock into and relate to. But with this, I didn’t have a physical relation to it, it was more of a mental thing. I couldn’t understand where the beginnings and endings were, where the phrases were. It was from another planet. (p. 90)

                This quote captures a common experience for people who are new to the tabla: it is both fascinating and confusing at the same time. You feel that something really great is happening, but you’re not sure what it is.

                This is the reality of classical tabla: it is not only difficult to understand, but also radically different from most other drumming traditions. And so there is little which can prepare you, even if you’re Mickey Hart.

                In order to make any sense of classical tabla, you must learn at least the basics of these elements:

                The tabla’s syllables and patterns: bol
                The tabla’s performance environment: tal
                The most common compositional forms: kayda, rela, tukra, etc.
                If you put some effort into learning a little about these three things, then you should begin to hear classical tabla. And when that happens, a surprisingly rich, elegant, funky, and complex drumming tradition will begin to reveal itself.
             </p>
             <br/>
            <div className="abroad-div">
            <img className="abroad" src="https://upload.wikimedia.org/wikipedia/commons/f/f0/Ustad_Zakir_Hussain_2.jpg" alt="abroad"/>
             
            </div>
            <br/>
            <br/>
            <div className='what-button-div'>
                 <Link to="/"><button class="back" type="button">Back</button></Link>  
                 
        </div>  
    </div>)
}
export default Classical